import { template as template_b9a923c0293049c1953a99d6dfeb6271 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_b9a923c0293049c1953a99d6dfeb6271(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
